import React from 'react'

/*
 * Simplified image component that uses standard img tags.
 * Replaces gatsby-image to avoid sharp dependency issues on ARM Macs.
 */

const Image = props => {
  // Import images from src/images folder
  const imageSrc = require(`../../images/${props.filename}`)
  return <img src={imageSrc} alt={props.alt || ''} style={{ width: '100%', height: 'auto', ...props.style }} />
}

export default Image
